import { graphql } from "react-relay";

export const RemoveJiraInstanceMutation = graphql`
  mutation RemoveJiraInstanceMutation($input: RemoveJiraInstanceInput!) {
    removeJiraInstance(input: $input) {
      problems {
        message
      }
      removed {
        id @deleteRecord
      }
    }
  }
`;
